<template>
  <div>
    <!-- 未执行飞行活动 -->
    <BasicTable :tableColumn="tableColumn_1" :tableData="taskPlanList" :actions="actions_1"
                :showAddButton="uBtnPermissionList.includes('insert')"
                searchPlaceholder="型号,执照号,运营人,驾驶员,起/降点,空域,航线,备注"
                :tableTitle="tableTitle_1" :showSearch="true" @add-item="addPlanClick" ref="taskPlanList" :isPart="true"
                @search-item="searchItem1"
                :current="current" :total="total" :size="size" @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
    >
      <template #customCol>
        <el-table-column prop="type" label="任务类型" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">观光</span>
            <span v-else-if="scope.row.type == 1">巡检</span>
            <span v-else-if="scope.row.type == 2">物流</span>
            <span v-else-if="scope.row.type == 3">应急</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" min-width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!--            <span v-if="scope.row.status === 0">待审批</span>
                        <span v-if="scope.row.status === 1">待激活</span>
                        <span v-if="scope.row.status === 2">已激活</span>-->
            <span v-if="scope.row.category === 2">报备飞行活动</span>
            <span v-if="scope.row.category !== 2&&!isAdmin">{{planStatusOptions.filter(v=>(v.value===scope.row.status))[0].label}}</span>
            <el-select v-if="scope.row.category !== 2&&isAdmin" v-model="scope.row.status" @change="(e)=>{changeStatus(e,scope.row.id)}" placeholder="请选择" >
              <el-option
                v-for="item in planStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="planSerial" label="活动编号" align="center" min-width="60" :show-overflow-tooltip="true">
        </el-table-column> -->
        <el-table-column prop="note" label="备注" align="center" min-width="60" :show-overflow-tooltip="true">
        </el-table-column>
      </template>
      <!-- customBtn自定义操作列 -->
      <template #customBtn>
        <el-table-column label="操作" align="center" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.category !== 2&&scope.row.status === 1&&uBtnPermissionList.includes('update')">
              <el-button @click="handleUpdate(scope.row)" type="text" size="small">修改</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 2&&uBtnPermissionList.includes('applyPlan')">
              <el-button @click="handelFlying(scope.row.id)" type="text" size="small">放飞申请</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 4&&uBtnPermissionList.includes('applyIn')">
              <el-button @click="handelApplyIn(scope.row.id)" type="text" size="small">进场申请</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 6&&uBtnPermissionList.includes('noticeIn')">
              <el-button @click="handelNoticeIn(scope.row.id)" type="text" size="small">进场告知</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 7&&uBtnPermissionList.includes('applyTakeOff')">
              <el-button @click="handelApplyTakeOff(scope.row.id)" type="text" size="small">起飞申请</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 9&&uBtnPermissionList.includes('noticeTakeOff')">
              <el-button @click="handelNoticeTakeOff(scope.row.id)" type="text" size="small">起飞告知</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span>
              <el-button v-if="uBtnPermissionList.includes('check')" @click="handleView(scope.row)" type="text" size="small">查看</el-button>
            </span>
          </template>
        </el-table-column>
      </template>
    </BasicTable>
    <!-- 已执行飞行活动 -->
    <BasicTable :tableColumn="tableColumn_2" :tableData="taskPlanCompletedList" :actions="actions_2"
                :tableTitle="tableTitle_2" ref="taskPlanCompletedList" :isPart="true" :showSearch="true"
                :hasAddBtn="false" @search-item="searchItem2"
                searchPlaceholder="型号,执照号,运营人,驾驶员,起/降点,空域,航线,备注"
                :current="currentExcuted" :total="totalExcuted" :size="sizeExcuted"
                @size-change="handleSizeChange_excuted" @current-change="handleCurrentChange_excuted"
    >
      <template #customCol>
        <el-table-column prop="type" label="任务类型" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">观光</span>
            <span v-else-if="scope.row.type == 1">巡检</span>
            <span v-else-if="scope.row.type == 2">物流</span>
            <span v-else-if="scope.row.type == 3">应急</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" min-width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!--            <span v-if="scope.row.status === 3">正在执行</span>
                        <span v-else-if="scope.row.status === 4">已执行</span>-->
            <!--            <span v-if="scope.row.status === 10&&!isAdmin">已激活(已起飞)</span>-->
            <!--            <span v-if="scope.row.status === 11&&!isAdmin">已激活(降落申请)</span>-->
            <!--            <span v-if="scope.row.status === 12&&!isAdmin">已激活(降落申请通过)</span>-->
            <!--            <span v-if="scope.row.status === 13&&!isAdmin">已降落</span>-->
            <!--            <span v-if="scope.row.status === 14&&!isAdmin">已离场</span>-->
            <span v-if="scope.row.category === 2">报备飞行活动</span>
            <span v-if="scope.row.category !== 2&&!isAdmin">{{planStatusOptions.filter(v=>(v.value===scope.row.status))[0].label}}</span>
            <el-select v-if="scope.row.category !== 2&&isAdmin" :disabled="scope.row.status === 14" v-model="scope.row.status" @change="(e)=>{changeStatus(e,scope.row.id)}" placeholder="请选择" >
              <el-option
                v-for="item in planStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="planSerial" label="活动编号" align="center" min-width="60" :show-overflow-tooltip="true">
        </el-table-column> -->
        <el-table-column prop="note" label="备注" align="center" min-width="60" :show-overflow-tooltip="true">
        </el-table-column>
      </template>
      <!-- 手动结束操作 -->
      <!-- <template #customBtn>
        <el-table-column label="操作" align="center" min-width="40">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 3">
              <el-button @click="handleComplete(scope.row.id)" type="text" size="small">结束</el-button>
            </span>
          </template>
        </el-table-column>
      </template> -->
      <!-- customBtn自定义操作列 -->
      <template #customBtn>
        <el-table-column label="操作" align="center" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.category !== 2&&scope.row.status === 10&&uBtnPermissionList.includes('applyDown')">
              <el-button @click="handelApplyDown(scope.row.id)" type="text" size="small">降落申请</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 12&&uBtnPermissionList.includes('noticeDown')">
              <el-button @click="handelNoticeDown(scope.row.id)" type="text" size="small">降落告知</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span v-if="scope.row.category !== 2&&scope.row.status === 13&&uBtnPermissionList.includes('noticeLeave')">
              <el-button @click="handelNoticeLeave(scope.row.id)" type="text" size="small">离场告知</el-button>
              <!--              <el-button @click="issueCompletedPlan(scope.row.id)" type="text" size="small">下达</el-button>-->
            </span>
            <span>
              <el-button v-if="uBtnPermissionList.includes('check')" @click="handleView(scope.row)" type="text" size="small">查看</el-button>
            </span>
          </template>
        </el-table-column>
      </template>
    </BasicTable>

    <BasicForm :isStyleApplied="isStyleApplied" :dialogVisible="clickButton" :dialogTitle="dialogTitle" :formModel="taskForm" :btnName="btnName"
               @submit="submitPlan" @update:dialogVisible="updateDialogVisible" :formRules="formRules">
      <el-row>
        <el-alert
          :title="alertNotice"
          type="info"
          show-icon
          :closable="false">
        </el-alert>
        <el-col :span="24">
          <el-form-item  class="category" label="活动类型" prop="category" align="left">
            <el-radio-group v-model="taskForm.category" :disabled="ifView">
              <el-radio :key=1 :value="1" :label=1 style="color: whitesmoke">正常飞活动</el-radio>
              <el-radio :key=2 :value="2" :label=2 style="color: whitesmoke">报备飞活动</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
        <el-form-item label="运营人编号" prop="operatorNum">
          <el-input
            class="formInputClass"
            placeholder="请填写运营人编号"
            maxlength="200"
            v-model="taskForm.operatorNum"
          >
          </el-input
        ></el-form-item>
        </el-col> -->
        <el-col :span="12">
          <!--          <el-form-item label="运营人名称" prop="operatorName">
                      <el-input class="formInputClass" placeholder="请填写运营人名称" maxlength="200" v-model="taskForm.operatorName" :disabled="ifView">
                      </el-input></el-form-item>-->
          <el-form-item label="运营人名称" prop="operatorNum">
            <el-select v-model="taskForm.operatorNum" placeholder="请填写运营人名称" popper-class="adminHomeSelect"
                       @change="handleOperChange" :disabled="ifView">
              <el-option v-for="oper in opers" :key="oper.operatorNum" :label="oper.operatorName"
                         :value="oper.operatorNum"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运营人执照号" prop="operatorLicense">
            <el-input class="formInputClass" placeholder="请填写运营人执照号" maxlength="200"
                      v-model="taskForm.operatorLicense" disabled>
            </el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="驾驶员名称" prop="pilotId">
            <el-select v-model="taskForm.pilotId" filterable placeholder="请选驾驶员信息" popper-class="adminHomeSelect"
                       @change="handleFlyerChange" :disabled="ifView||!taskForm.operatorNum">
              <el-option v-for="flyer in flyers" :key="flyer.pilotId" :label="flyer.pilot"
                         :value="flyer.pilotId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="驾驶员执照号" prop="pilotLicense">
            <el-input class="formInputClass" placeholder="请填写驾驶员执照号" maxlength="200"
                      v-model="taskForm.pilotLicense" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>

        <el-col :span="12">
          <el-form-item label="飞机序列号" prop="uavSerial">
            <el-select v-model="taskForm.uavSerial" placeholder="请选择飞机" filterable popper-class="adminHomeSelect"
                       @change="handleAircraftChange" :disabled="ifView||!taskForm.operatorNum"
                       :filter-method="filterAircraft">
              <el-option v-for="aircraft in aircrafts" :key="aircraft.productId" :label="aircraft.productId"
                         :value="aircraft.productId">
                <template>
                  <div class="aircraftList">
                    <span>序列号:  {{ aircraft.productId }}     </span>
                    <span>型号:  {{ aircraft.productModel }}    </span>
                    <span>名称-简称:  {{ aircraft.productName }} - {{ aircraft.simpleAircraftName }}</span>
                  </div>
                </template>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="飞机型号" prop="uavModel">
            <el-input class="formInputClass" placeholder="请选择飞机型号" maxlength="200" v-model="taskForm.uavModel"
                      disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="起飞点" prop="startPointId">
            <el-select
              :disabled="ifView"
              v-model="taskForm.startPointId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请搜索选择起飞点"
              popper-class="adminHomeSelect"
              @focus="remoteSearchStartPoint('')"
              :remote-method="remoteSearchStartPoint"
              :loading="startLoading">
              <el-option
                v-for="item in startLandPoints"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="降落点" prop="endPointId">
            <el-select
              :disabled="ifView"
              v-model="taskForm.endPointId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请搜索选择降落点"
              popper-class="adminHomeSelect"
              @focus="remoteSearchEndPoint('')"
              :remote-method="remoteSearchEndPoint"
              :loading="endLoading">
              <el-option
                v-for="item in endLandPoints"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="起飞时间" prop="startTime">
            <el-date-picker
              class="formInputClass"
              v-model="taskForm.startTime"
              type="datetime"
              placeholder="请选择起飞时间"
              maxlength="200"
              :disabled="ifView"
              :picker-options="disabledStartDate"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="降落时间" prop="endTime">
            <el-date-picker
              class="formInputClass"
              placeholder="请选择降落时间"
              maxlength="200"
              v-model="taskForm.endTime"
              type="datetime"
              :disabled="ifView"
              :picker-options="disabledEndDate"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="任务类型" prop="type">
            <el-input class="formInputClass" placeholder="请填写任务类型" maxlength="200" v-model="taskForm.type"
              :disabled="isDetail">
            </el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="航线信息" prop="routeId">
            <el-select v-model="taskForm.routeId" placeholder="请搜索选择航线信息" popper-class="adminHomeSelect"
                       @change="handleAirlineChange"
                       :disabled="ifView"
                       filterable
                       remote
                       clearable
                       reserve-keyword
                       @focus="remoteSearchLine('')"
                       :remote-method="remoteSearchLine"
                       :loading="lineLoading">
              <el-option v-for="line in airlines" :key="line.id" :label="line.name" :value="line.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务类型" prop="type">
            <el-select v-model="taskForm.type" placeholder="请选择任务类型" popper-class="adminHomeSelect"
                       :disabled="taskType">
              <el-option v-for="type in typeList" :key="type.id" :label="type.name" :value="type.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="空域信息" prop="spaceId" v-if="showSpace">
            <el-select v-model="taskForm.spaceId" placeholder="请选择空域信息" popper-class="adminHomeSelect"
                       :disabled="ifView"
                       filterable
                       clearable>
              <el-option v-for="space in spaces" :key="space.spaceId" :label="space.spaceName"
                         :value="space.spaceId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="飞行高度" prop="height" v-if="showSpace">
            <el-input class="formInputClass" type="number" placeholder="请填写飞行高度" maxlength="200"
                      v-model="taskForm.height" :disabled="ifView"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input placeholder="备注信息" maxlength="200" type="textarea" v-model="taskForm.note" :disabled="ifView">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="驳回原因" prop="reason" v-if="showReason">
            <el-input placeholder="驳回原因" maxlength="200" type="textarea" v-model="taskForm.refuseReason"
                      :disabled="true">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </BasicForm>

    <div class="rightDiv" v-show="isDetail">
      <div class="planCirculationTimelineBox" v-if="activeAccordionName === 'planCirculationInfo'">
        <div class="planCirculationTimelineBoxTitle">计划流转信息</div>
        <div :class="[
          'planCirculationTimelineBoxContent',
          isConfirm ? 'isConfirm' : '',
        ]">
          <el-timeline class="planCirculationTimelineBoxContentInfo" :reverse="true">
            <el-timeline-item placement="top" v-for="(planCirculationInfo, index) in planCirculationInfos" :class="index === planCirculationInfos.length - 1 ? 'fontFFA63E' : ''
              " :key="index" :icon="index === planCirculationInfos.length - 1 ? 'el-icon-check' : ''
                " :color="index === planCirculationInfos.length - 1 ? '#FFA63E' : '#fff'
                  " :size="index === planCirculationInfos.length - 1 ? 'large' : 'normal'
                    " :timestamp="planCirculationInfo.timestamp">
              {{ planCirculationInfo.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="rightBottomDiv" v-show="!isConfirm">
          <el- class="saveButton" v-show="isDetail" @click="submit('pass')">通过</el->
          <el-button class="rejectButton" v-show="isDetail" @click="submit('reject')">驳回</el-button>
        </div>
      </div>
      <div class="goodsListAndNote" v-else>
        <div :class="rightTopDiv">
          <div class="rightMainContainer">
            <div class="rightCommonTitle">
              <div class="title">
                <i class="header-icon el-icon-goods-plan"></i>
                &nbsp;货物列表
              </div>
              <div class="title">货物名称:&nbsp;&nbsp;{{ goodsName }}</div>
            </div>
            <el-table :data="goodsList" class="goodsList" ref="goodsList" :height="goodsListHeight"
                      :row-style="{ height: '40px' }" :cell-style="changeCellStyle"
                      :row-class-name="goodsListRowClassName"
                      tooltip-effect="light">
              <el-table-column label="序号" align="center" prop="index" min-width="60"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="local_id" label="货物编号" align="center" min-width="150"
                               :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column label="体积（长*宽*高）/cm" align="center" min-width="180"
                               :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.goods_length }}* {{ scope.row.goods_width }}*
                    {{ scope.row.goods_height }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="重量/kg" align="center" min-width="80"
                               prop="goods_weight" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="属性"
                               min-width="220" prop="attributes" align="center"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="类型" align="center"
                               prop="goods_type_name" min-width="80" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column
                label="包装" align="center" min-width="100" prop="goods_package_name"
                :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="密级" align="center"
                               min-width="60" prop="goods_secrecy_id" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.goods_secrecy_id === 0">非<span>密</span></span>
                  <span v-else-if="scope.row.goods_secrecy_id === 1">秘<span>密</span></span>
                  <span v-else-if="scope.row.goods_secrecy_id === 2">机<span>密</span></span><span
                  v-else-if="scope.row.goods_secrecy_id === 3">绝<span>密</span></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="rightCenterDiv">
          <div class="rightCommonTitle">
            <div class="title">
              <i class="header-icon el-icon-remark"></i>&nbsp;审批意见
            </div>
            <div class="separator"></div>
          </div>
          <!-- <div class="remark">
            <div :class="history">
              <div class="title">流转信息:</div>
              <div class="content">
                <span v-for="(item, index) in note" :key="index">
                  &nbsp; {{ item }}<br />
                </span>
              </div>
            </div>
            <div v-show="!isConfirm" class="seperate"></div>
            <el-input
              v-show="!isConfirm"
              type="textarea"
              v-model="flight.note"
              placeholder="请输入审批意见(500字内，且不能输入$)"
              maxlength="500"
              @input="change($event)"
            ></el-input>
          </div> -->

          <div class="remarkDiv">
            <div class="historyButton">
              <div v-if="!isConfirm" :class="!isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
                   @click="isHistory = false">
                新增备注
              </div>
              <div :class="isHistory ? 'remarkClassNow' : 'remarkClassHistory'" @click="isHistory = true">
                历史备注
              </div>
            </div>
            <div v-if="isHistory">
              <div class="historyRemark">
                <span v-for="(item, index) in note" :key="index">
                  {{ item }}<br/>
                </span>
              </div>
            </div>
            <div v-else-if="!isConfirm">
              <el-input style="height: 220px" placeholder="请输入备注(500字内，且不能输入$)" @input="change($event)"
                        type="textarea"
                        maxlength="500" v-model="flight.note"></el-input>
            </div>
            <!-- <div :class="history">
              <div class="title">流转信息:</div>
              <div class="content">
                <span v-for="(item, index) in note" :key="index">
                  &nbsp; {{ item }}<br />
                </span>
              </div>
            </div>
            <div v-show="!isConfirm" class="seperate"></div>
            <el-input
              v-show="!isConfirm"
              type="textarea"
              v-model="flight.note"
              placeholder="请输入备注(500字内，且不能输入$)"
              maxlength="500"
              @input="change($event)"
            ></el-input> -->
          </div>
          <div class="relations">
            <el-checkbox-group v-model="relations">
              <el-checkbox disabled v-for="(item, index) in confirmRelations" :key="index" :label="item.id">{{
                  item.label
                }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="rightBottomDiv" v-show="!isConfirm">
          <el-button class="saveButton" v-show="isDetail" @click="submit('pass')">
            通过
          </el-button>
          <el-button class="rejectButton" v-show="isDetail" @click="submit('reject')">
            驳回
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import taskIcon from "../../assets/img/home/task.png";
import minimumer from "../../assets/img/home/minimumer.png";
import secondaryer from "../../assets/img/home/secondaryer.png";
import highester from "../../assets/img/home/highester.png";

import parkingApron1 from "../../assets/img/taskPlan/parkingApron1.png";
import parkingApron1Hover from "../../assets/img/taskPlan/parkingApron1Hover.png";
import parkingApron2 from "../../assets/img/taskPlan/parkingApron2.png";
import parkingApron2Hover from "../../assets/img/taskPlan/parkingApron2Hover.png";

import tooltipOver from "../tools/tooltipOver";
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";

export default {
  name: "PlanApproval",
  props: {
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
    userInfo:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      planStatusOptions:[{
        value: 0,
        label: '待审批'
      }, {
        value: 1,
        label: '已驳回'
      }, {
        value: 2,
        label: '已审批'
      }, {
        value: 3,
        label: '放飞申请'
      }, {
        value: 4,
        label: '放飞申请通过'
      },{
        value: 5,
        label: '进场申请'
      },{
        value: 6,
        label: '进场申请通过'
      },{
        value: 7,
        label: '已进场'
      },{
        value: 8,
        label: '执飞申请'
      },{
        value: 9,
        label: '执飞申请通过'
      },{
        value: 10,
        label: '已激活(已起飞)'
      },
        {
          value: 11,
          label: '已激活(降落申请)'
        },
        {
          value: 12,
          label: '已激活(降落申请通过)'
        },
        {
          value: 13,
          label: '已降落'
        },{
          value: 14,
          label: '已离场'
        }],
      startLoading:false,
      alertNotice:'全部计划',
      airspaceLoading:false,
      startLandPoints:[],
      endLoading:false,
      lineLoading:false,
      endLandPoints:[],
      operator: '',//运营人id
      activeAccordionName: "deliveryTime", //当前打开的手风琴名称
      // 存储 计划流转信息
      planCirculationInfos: [],

      landPoints: [], //起降点
      airlines: [], //航线信息
      flyers: [], //飞手信息
      opers: [], //运营人信息
      spaces: [], //空域信息
      aircrafts: [], //飞机信息
      taskType:true,
      rules: {
        landPoint_id: [
          {required: true, message: "请选择起降点~", trigger: "blur"},
        ],
      },

      clickButton: false,
      // clickShowReport: false,
      taskIcon: taskIcon,
      waitApprovalNum: 0,
      approvalNum: 0,
      rejectedNum: 0,

      opacityOfWaitApproval: "opacity: 1;",
      opacityOfApproval: "opacity: 0.4;",
      opacityOfRejected: "opacity: 0.4;",
      openTab: "waitApproval",

      isConfirm: false,
      // 是否是查看详情
      isDetail: false,
      isHistory: false,

      rightTopDiv: "rightTopDiv",
      goodsListHeight: 235,
      history: "history",

      queryForm: {
        FlightApproved: 0, //0为待审批，1为审批通过，-1为驳回
        condition: "",
        currentpage: 1,
        pagesize: 0,
      },

      taskForm: {
        id: "",
        category: 1,
        planSerial: "",
        uavSerial: "",
        uavModel: "",
        pilotLicense: "",
        pilot: "",
        pilotId: "",
        operatorName: "",
        operatorNum: "",
        operatorLicense: "",
        startPointId: "",
        startPoint: {},
        endPointId: "",
        endPoint: {},
        startTime: "",
        endTime: "",
        routeId: "",
        spaceId: "",
        height: "",
        type: "",
        note: "",
      },

      priorityClass: "",
      priority: null,

      itemList: [],
      itemCompletedList: [],
      // 未执行飞行活动
      tableColumn_1: [
        {label: "飞机序列号", prop: "uavSerial"},
        {label: "飞机型号", prop: "uavModel"},
        // { label: "驾驶员执照号", prop: "pilotLicense" },
        {label: "驾驶员名称", prop: "pilot"},
        //{ label: "运营人编号", prop: "operatorNum" },
        // { label: "运营人执照号", prop: "operatorLicense" },
        {label: "运营人名称", prop: "operatorName"},
        {label: "起飞点", prop: "startPoint"},
        {label: "起飞时间", prop: "startTime"},
        {label: "降落点", prop: "endPoint"},
        {label: "降落时间", prop: "endTime"},
        {label: "航线信息", prop: "routeName"},
        {label: "空域信息", prop: "spaceName"},
        {label: "飞行高度", prop: "height"},
        // { label: "任务类型", prop: "type" },
        // { label: "状态", prop: "status" },
        // { label: "活动编号", prop: "planSerial" },
        // { label: "备注", prop: "note" },
      ],
      // 已执行飞行活动
      tableColumn_2: [
        {label: "飞机序列号", prop: "uavSerial"},
        {label: "飞机型号", prop: "uavModel"},
        // { label: "驾驶员执照号", prop: "pilotLicense" },
        {label: "驾驶员名称", prop: "pilot"},
        //{ label: "运营人编号", prop: "operatorNum" },
        // { label: "运营人执照号", prop: "operatorLicense" },
        {label: "运营人名称", prop: "operatorName"},
        {label: "起飞点", prop: "startPoint"},
        {label: "起飞时间", prop: "startTime"},
        {label: "降落点", prop: "endPoint"},
        {label: "降落时间", prop: "endTime"},
        {label: "航线信息", prop: "routeName"},
        {label: "空域信息", prop: "spaceName"},
        {label: "飞行高度", prop: "height"},
        // { label: "任务类型", prop: "type" },
        // { label: "状态", prop: "status" },
        // { label: "活动编号", prop: "planSerial" },
        // { label: "备注", prop: "note" },
      ],
      taskPlanList: [],
      taskPlanCompletedList: [],
      actions_1: [],
      actions_2: [],
      tableTitle_1: "预战术阶段计划未执行", //表格标题
      tableTitle_2: "预战术阶段计划已执行",
      dialogTitle: "", //表单名
      btnName: "", //表单提交按钮名字

      goodsName: "", //货物名称
      goodsList: [], //货物列表信息

      openedId: null, //已展开的任务
      flight: {}, // 计划信息
      applyer: {}, //提报人
      auditor: {}, //审核员
      customer_groundstaf: {}, //发货地勤
      destination_groundstaf: {}, //收货地勤
      flyer: {}, //飞手
      security: {}, //保障员
      task_controller: {}, //任务控制
      uav: {uavmodel: {}}, //无人机
      airlink: {}, //链路信息
      starstaypoint: {}, //起始驻点
      endstaypoint: {}, //结束驻点
      note: "",

      replaceStr: "$", //分隔符

      relations: [],
      // 确认关系
      confirmRelations: [
        {
          id: 0,
          label: "空域确认",
        },
        {
          id: 1,
          label: "气象确认",
        },
        {
          id: 2,
          label: "地理确认",
        },
        {
          id: 3,
          label: "电磁确认",
        },
      ],

      parkingApron1: parkingApron1,
      parkingApron1Hover: parkingApron1Hover,
      parkingApron2: parkingApron2,
      parkingApron2Hover: parkingApron2Hover,
      formClass: "",
      flag: false,
      // 定义表单必填校验
      formRules: [
        {label: '活动类型', prop: 'category'},
        {label: '飞机序列号', prop: 'uavSerial'},
        {label: '飞机型号', prop: 'uavModel'},
        {label: '驾驶员执照号', prop: 'pilotLicense'},
        {label: '驾驶员名称', prop: 'pilotId'},
        {label: '运营人执照号', prop: 'operatorLicense'},
        {label: '运营人名称', prop: 'operatorNum'},
        {label: '起飞点', prop: 'startPointId'},
        {label: '降落点', prop: 'endPointId'},
        {label: '起飞时间', prop: 'startTime'},
        {label: '降落时间', prop: 'endTime'},
        {label: '任务类型', prop: 'type'},
        {label: '航线信息', prop: 'routeId'},
      ],
      formRules1: [
        {label: '任务类型', prop: 'type'},
        {label: '航线信息', prop: 'routeId'},
      ],
      formRules2: [
        {label: '空域信息', prop: 'spaceId'},
        {label: '飞行高度', prop: 'height'},
      ],
      ifView: false,
      showReason: false, //驳回原因是否展示
      showSpace: false, //空域信息是否展示
      total: 0, //总条数
      current: 1, //当前页数
      size: 6, //显示几条
      totalExcuted: 0, //已执行计划列表总条数
      currentExcuted: 1, //已执行计划列表当前页数
      sizeExcuted: 6, //已执行计划列表显示几条
      typeList: [
        {id: 0, name: "观光"},
        {id: 1, name: "巡检"},
        {id: 2, name: "物流"},
        {id: 3, name: "应急"},
      ],
      searchKey1: '', // 未执行搜索关键字
      searchKey2: '', // 已执行搜索关键字
    };
  },
  watch: {
    "taskForm.operatorNum": {
      handler(v) {
        if (this.operatorId) {
          this.queryFlyer();
          this.queryAircraft()
        }
      }
    },
    'taskForm.spaceId':{
      handler(v) {
        if (this.taskForm.spaceId) {
          this.taskType = false
        }
      }
    }
  },
  computed: {
    isAdmin(){
      return sessionStorage.getItem("roleId") === '2'
    },
    uBtnPermissionList() {
      return  this.getPageBtnRole('planApproval')||[]
    },
    // 时间选择器限制 开始时间小于结束时间
    disabledStartDate() {
      const nowDate = new Date()
      //选择的日期
      let curDate = this.$moment(this.taskForm.startTime).format("YYYY-MM-DD")
      if (this.taskForm.endTime) {
        //最大日期
        let maxDate = this.$moment(this.taskForm.endTime).format("YYYY-MM-DD")
        // 如果选择的日期为最大日期，则设置为最大日期的时分秒
        let str = ""
        if (curDate == maxDate) {
          str = this.$moment(this.taskForm.endTime).format("HH:mm:ss")
        } else {
          str = "23:59:59"
        }
        return {
          disabledDate: (time) => {
            return time.getTime() > this.taskForm.endTime
            // return    time.getTime() < nowDate - 24 * 3600000 || time.getTime() > this.taskForm.endTime
          },
          selectableRange: "00:00:00 - " + str,
          // selectableRange: str + " - 23:59:59", ,
        }
      } else {
        return {
          disabledDate: (time) => {
            // return false
            return time.getTime() < nowDate - 24 * 3600000
          },
        }
      }
    },
    disabledEndDate(time) {
      //选择的日期
      let curDate = this.$moment(this.taskForm.endTime).format("YYYY-MM-DD")
      if (this.taskForm.startTime) {
        //最小日期
        let minDate = this.$moment(this.taskForm.startTime).format("YYYY-MM-DD")
        //前推一天，防止当天日期无法选择
        let preTime = this.taskForm.startTime - 24 * 3600000
        // 如果选择的日期为最小日期，则设置为最小日期的时分秒
        let str = ""
        if (curDate == minDate) {
          str = this.$moment(this.taskForm.startTime).format("HH:mm:ss")
        } else {
          str = "00:00:00"
        }
        return {
          disabledDate: (time) => {
            return time.getTime() < preTime
          },
          selectableRange: str + " - 23:59:59",
        }
      } else {
        return {
          disabledDate: () => {
            return false
          },
        }
      }
    },
  },
  components: {
    "tooltip-over": tooltipOver,
    BasicTable, //公共表格
    BasicForm, //公共弹框
  },
  methods: {
    async setNotice(){
      const request1 = this.getRequest(
        "/user-server/systemConfig/getSystemConfigByKey?key=pre_tactical_phase_plan_create_time_begin  "
      );
      const request2 = this.getRequest(
        "/user-server/systemConfig/getSystemConfigByKey?key=pre_tactical_phase_plan_create_time_end"
      );
      // 并行执行两个请求，等待全部完成
      const [res1, res2] = await Promise.all([request1, request2]);
      // 处理第一个请求结果
      const oData1 = res1.data;
      const oData2 = res2.data;
      if (oData1.code === 0 && oData2.code === 0) {
        this.alertNotice = `预战术阶段计划起飞时间需提前${Math.trunc(oData2.data.configValue / 24)}天${oData2.data.configValue % 24}小时(不含)且提前不超过${Math.trunc(oData1.data.configValue / 24)}天${oData1.data.configValue % 24}小时(含)`;
      } else {
        this.$message({
          message: oData1.msg + oData2.msg,
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-ok-tip",
          offset: 470,
        });
      }
    },
    changeStatus(v,id){
      this.postJsonRequest(`/uav-task-server/plan/changePlanStatus?id=${id}&status=${v}`).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
            });
            this.unExecutedPlan();
            this.executedPlan();
          } else {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
            })
            this.unExecutedPlan();
            this.executedPlan();
          }
        })
    },
    //获取时间戳时分秒
    toHHmmss(date) {
      var time;
      var hours = parseInt((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (date % (1000 * 60)) / 1000;
      time = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
      return time;
    },
    // 关闭对话框时获取子组件传过来的状态
    updateDialogVisible(newVal) {
      this.clickButton = newVal;
      this.showReason = false
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.unExecutedPlan();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.unExecutedPlan();
    },
    handleSizeChange_excuted: function (size) {
      this.sizeExcuted = size;
      this.executedPlan();
    },
    handleCurrentChange_excuted: function (current) {
      this.currentExcuted = current;
      this.executedPlan();
    },
    change(e) {
      this.$forceUpdate();
      // 限制输入特殊字符$
      this.flight.note = e.replace(this.replaceStr, "");
    },
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "customClass-style",
        iconClass: "",
        confirmButtonClass: "confirm-style",
        showCancelButton: false,
      });
    },
    getUnixTimestamp() {
      const now = new Date();
      return Math.floor(now.getTime() / 1000);
    },
    spaceRules() {
      this.formRules.pop();
      this.formRules.pop();
      this.formRules.push(...this.formRules2);
    },
    lineRules() {
      this.formRules.pop();
      this.formRules.pop();
      this.formRules.push(...this.formRules1);
    },
    waitApproval() {
      if (this.openTab !== "waitApproval") {
        this.opacityOfWaitApproval = "opacity: 1;";
        this.opacityOfApproval = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.isConfirm = false;
        this.isHistory = false;
        this.isDetail = false;
        this.rightTopDiv = "rightTopDiv";
        this.goodsListHeight = 235;
        this.history = "history";

        this.queryForm.FlightApproved = 0;
        this.getConfirmRelationListByFlightApproved();
      }
      this.openTab = "waitApproval";
    },
    approval() {
      if (this.openTab !== "approval") {
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfApproval = "opacity: 1;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.isConfirm = true;
        this.isHistory = true;
        this.isDetail = false;
        this.rightTopDiv = "rightConfirmTopDiv";
        this.goodsListHeight = 293;
        this.history = "historyDiv";
        this.queryForm.FlightApproved = 1;
        this.getConfirmRelationListByFlightApproved();
      }
      this.openTab = "approval";
    },
    rejected() {
      if (this.openTab !== "rejected") {
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfApproval = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 1;";
        this.openedId = null;
        this.isConfirm = true;
        this.isHistory = true;
        this.isDetail = false;
        this.rightTopDiv = "rightConfirmTopDiv";
        this.goodsListHeight = 293;
        this.history = "historyDiv";
        this.queryForm.FlightApproved = -1;
        this.getConfirmRelationListByFlightApproved();
      }
      this.openTab = "rejected";
    },
    resetSpace() {
      this.lineRules();
      this.showSpace = false;
      this.taskForm.spaceId = '';
      this.taskForm.height = '';
    },
    getConfirmRelationStaticByFlightApproved() {
      this.getRequest(
        "/uav-task-server/confirmrelation/getConfirmRelationStaticByFlightApproved.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.waitApprovalNum = data.WatingFlightApproved;
            this.approvalNum = data.FlightApproved;
            this.rejectedNum = data.FlightRej;
          } else {
            this.waitApprovalNum = 0;
            this.approvalNum = 0;
            this.rejectedNum = 0;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>计划统计获取失败";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            confirmButtonClass: "confirm-style",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },

    async submitPlan() {
      let params = {
        ...this.taskForm,
      };
      params.endTime = this.$moment(params.endTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      params.startTime = this.$moment(params.startTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      if (params.endTime <= params.startTime) {
        this.$message.error('降落时间必须晚于起飞时间');
        this.taskForm.endTime = null; // 清空降落时间
        return
      }
      if (this.dialogTitle === "新增") {
        this.showReason = false
        const now = new Date();
        params.planSerial = Math.floor(now.getTime() / 1000);
        await this.addPlan(params);
      } else if (this.dialogTitle === "修改") {
        // console.log('修改dialogTitle--TODO', params)
        await this.updatePlan(params);
      }
      ;
      this.showReason = false;
      this.clickButton = false;
    },

    sleep(param) {
      this.$message({
        message: "休息一下吧",
      });
    },

    addPlan(param) {
      param = { ...param, planType: 2 };
      this.postJsonRequest("/uav-task-server/plan/createPlan", param).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
            });
            this.unExecutedPlan();
          } else {
            //this.$message.error(oData.msg);
            this.$message({
              message: oData.msg,
              duration: 10000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
            });
          }
          /*if (res.data) {
            this.$message({
              message: "新增成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
            });
            // 新建成功后刷新
            this.unExecutedPlan();
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              confirmButtonClass: "confirm-style",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }*/
        }
      );
    },

    async issueCompletedPlan(paramId) {
      await this.issuePlan(paramId);
    },

    issuePlan(paramId) {
      //const param = this.taskPlanList.id;
      this.postJsonRequest(
        "/uav-task-server/plan/activePlan?planId=" + paramId
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.$message({
            message: "飞行活动下达成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            },
          });
          // // 下达成功后再次请求页面
          this.unExecutedPlan();
        } else if (oData.code != 401) {
          // let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          // this.$confirm(tips, "提示", {
          //   confirmButtonText: "好的",
          //   customClass: "customClass-style",
          //   iconClass: "",
          //   confirmButtonClass: "confirm-style",
          //   dangerouslyUseHTMLString: true,
          //   showCancelButton: false,
          // });
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      });
    },
    // 手动结束
    handleComplete(paramId) {
      this.getRequest(
        "/uav-task-server/plan/endPlan?id=" + paramId
      ).then((res) => {
        let oData = res.data;
        if (res.status === 200) {
          this.$message({
            message: "飞行活动结束成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            },
          });
          this.executedPlan();
        } else {
          this.$message({
            message: "操作失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    // 查看
    handleView(param) {
      this.rightCenterDiv = "centerDiv";
      this.formClass = "form";
      this.clickButton = true;
      this.dialogTitle = "查看";
      this.ifView = true;
      this.operatorId = param.operatorId
      this.startLandPoints = [{id:param.startPointId,name:param.startPoint}]
      this.endLandPoints = [{id:param.endPointId,name:param.endPoint}]
      this.airlines = [{id:param.routeId,name:param.routeName}]
      // this.queryAllCPoint();
      // this.queryAllCline();
      this.queryAircraft()
      this.queryFlyer()
      this.queryOper();
      this.querySpace();
      this.btnName = "关闭";
      this.taskForm = {...param};
      if (param.routeId === null) {
        this.showSpace = true;
        this.spaceRules();
      } else {
        this.showSpace = false;
        this.spaceRules();
      }
      if (param.status === 1) {
        this.showReason = true; //查看页面且状态为被驳回展示驳回原因
      } else {
        this.showReason = false;
      }
    },
    // 修改
    async handleUpdate(param) {
      this.rightCenterDiv = "centerDiv";
      this.formClass = "form";
      this.clickButton = true;
      this.dialogTitle = "修改";
      this.ifView = false;
      this.operatorId = param.operatorId
      // this.queryAllCPoint();
      this.startLandPoints = [{id:param.startPointId,name:param.startPoint}]
      this.endLandPoints = [{id:param.endPointId,name:param.endPoint}]
      this.airlines = [{id:param.routeId,name:param.routeName}]
      // this.queryAllCline();
      this.queryOper();
      this.querySpace();
      this.queryFlyer()
      this.btnName = "提交";
      this.taskForm = {...param};
      if (param.routeId === null) {
        this.showSpace = true;
        this.spaceRules();
      } else {
        this.showSpace = false;
        this.lineRules();
      }
      if (param.status === 1) {
        this.showReason = true; //查看页面且状态为被驳回展示驳回原因
      } else {
        this.showReason = false;
      }
    },
    updatePlan(param) {
      this.postJsonRequest("/uav-task-server/plan/updatePlan", param).then(
        (res) => {
          this.unExecutedPlan()
          let oData = res.data;
          if (res.status === 200) {
            if (oData.code === 0) {
              this.$message({
                message: oData.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
              });
            } else {
              //this.$message.error(oData.msg);
              this.$message({
                message: oData.msg,
                duration: 10000,
                customClass: "message-warn-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
              });
            }
            /*this.$nextTick(() => {
              this.unExecutedPlan();
              this.$message({
                message: "修改成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
              });
            });*/
          } else {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              },
            });
          }
        }
      );
    },

    // 删除
    handleDelete(paramId) {
      let tips =
        "<i class='el-icon-warn-tip'></i>是否确认删除?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest(
            "/uav-task-server/plan/deletePlan?id=" + paramId
          ).then((res) => {
            let oData = res.data;
            if (oData.code==0) {
              this.taskPlanList = this.taskPlanList.filter(item => item.id !== paramId);
              this.unExecutedPlan();
              this.$message({
                message: oData.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {
                },
              });
            } else {
              this.$message({
                message: oData.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () {
                },
              });
            }
          });
        })
        .catch((err) => {
        });
    },

    // getConfirmRelationListByFlightApproved() {
    //   // const param = this.getQueryParam(this.queryForm);
    //   this.getRequest(
    //     // "/uav-task-server/confirmrelation/getConfirmRelationListByFlightApproved.do?" +
    //     //   param
    //      "/uav-task-server/plandto/queryPlanDtoByCondition"
    //   ).then((res) => {
    //     let oData = res.data;

    //     //if (oData) {
    //       let planData = oData.data;
    //       for (let i = 0, len = planData.length; i < len; i++)
    //       {
    //         //console.log(planData[i]);
    //         if ((0 === planData[i].status|1 === planData[i].status|2 === planData[i].status) && !this.itemList.includes(planData[i].id)) {
    //           // this.taskPlanList = data.list
    //           this.taskPlanList.push(planData[i]);
    //           this.itemList.push(planData[i].id);
    //         }
    //       }
    //       // if ("0" == planData.status||"1" == planData.status||"2" == planData.status) {
    //       //   // this.taskPlanList = data.list
    //       //   this.taskPlanList = planData;
    //       // } else {
    //       //   this.taskPlanList = [];
    //       // }
    //     //}
    //     // else if (oData.code != 401) {
    //     //   let tips =
    //     //     "<i class='el-icon-warn-tip'></i>待执行计划列表获取失败";
    //     //   this.$confirm(tips, "提示", {
    //     //     confirmButtonText: "好的",
    //     //     customClass: "customClass-style",
    //     //     iconClass: "",
    //     //     confirmButtonClass: "confirm-style",
    //     //     dangerouslyUseHTMLString: true,
    //     //     showCancelButton: false,
    //     //   });
    //     // }
    //   });
    // },
    // getConfirmRelationListByFlightApprovedCompleted() {
    //   this.getRequest(
    //      "/uav-task-server/plandto/queryPlanDtoByCondition"
    //   ).then((res) => {
    //     let oData = res.data;
    //     let planData = oData.data;
    //       if (3 == planData.status||4 == planData.status) {
    //         this.taskPlanCompletedList = planData;
    //       } else {
    //         this.taskPlanCompletedList = [];
    //       }
    //   });
    // },

    unExecutedPlan() {
      this.getRequest(`/uav-task-server/plandto/queryPlan?status=0&status=1&status=2&status=5&status=3&status=4&status=6&status=7&status=8&status=9&currentpage=${this.current}&pagesize=${this.size}&planType=2&keyWord=${this.searchKey1}`)
        .then((res) => {
            let oData = res.data;
            if (0 == oData.code) {
              if (oData.data) {
                this.taskPlanList = oData.data.list;
                this.total = oData.data.total;
                this.current = oData.data.pageNum;
              } else {
                this.taskPlanList = [];
              }
            }
          }
        );
    },
    executedPlan() {
      this.getRequest(`/uav-task-server/plandto/queryPlan?status=10&status=11&status=12&status=13&status=14&currentpage=${this.currentExcuted}&pagesize=${this.sizeExcuted}&planType=2&keyWord=${this.searchKey2}`)
        .then((res) => {
            let oData = res.data;
            if (0 == oData.code) {
              if (oData.data) {
                this.taskPlanCompletedList = oData.data.list;
                this.totalExcuted = oData.data.total;
                this.currentExcuted = oData.data.pageNum;
              } else {
                this.taskPlanCompletedList = [];
              }
            }
          }
        );
    },

    async addPlanClick() {
      this.showSpace = false;
      this.rightCenterDiv = "centerDiv";
      this.formClass = "form";
      await this.setNotice()
      this.clickButton = true;
      this.dialogTitle = "新增";
      this.ifView = false;
      this.restPlanParams();
      this.queryAllCPoint();
      this.queryAllCline();
      this.queryOper();
      this.querySpace();
      this.btnName = "提交";
    },
    restPlanParams() {
      // 重置表单内容
      this.taskForm = {
        category: 1,
        planSerial: "",
        uavSerial: "",
        uavModel: "",
        pilotLicense: "",
        pilotId: "",
        operatorName: "",
        operatorNum: "",
        operatorLicense: "",
        startPointId: "",
        endPointId: "",
        startTime: "",
        endTime: "",
        routeId: "",
        type: "",
        note: "",
        spaceId: "",
        height: "",

      };
    },
    async commApi(id) {
      return await this.getRequest(
        `/uav-task-server/plan/applyPlan?id=${id}`
      )
    },
    //离场告知
    handelNoticeLeave(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.executedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //降落告知
    handelNoticeDown(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.executedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //降落申请
    handelApplyDown(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.executedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //起飞告知
    handelNoticeTakeOff(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.unExecutedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //执飞申请
    handelApplyTakeOff(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.unExecutedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //进场告知
    handelNoticeIn(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.unExecutedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //进场申请
    handelApplyIn(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.unExecutedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    //放飞
    handelFlying(id) {
      this.commApi(id).then(res => {
        if (res.data.code === 0) {
          this.unExecutedPlan()
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    clickTaskPlanRow(row) {
      this.activeAccordionName = "deliveryTime"; // 点击表格内计划信息时 重置 折叠面板
      this.openedId = row.id;
      this.setRelations(row);
      this.queryFlight(row.flight_id);
      this.isDetail = true;
      this.$refs.taskPlanList.toggleRowSelection(row);
    },
    setRelations(row) {
      let relations = [];
      let airspace_confirm = row.airspace_confirm;
      if (1 === airspace_confirm) {
        relations.push(0);
      }
      let meteorology_confirm = row.meteorology_confirm;
      if (1 === meteorology_confirm) {
        relations.push(1);
      }
      let geography_confirm = row.geography_confirm;
      if (1 === geography_confirm) {
        relations.push(2);
      }
      let electromagnetism_confirm = row.electromagnetism_confirm;
      if (1 === electromagnetism_confirm) {
        relations.push(3);
      }
      this.relations = relations;
    },
    remoteSearchStartPoint(query){
      this.startLoading = true;
      this.queryAllCPoint(query).then(res=>{
        this.startLandPoints = res
      })
    },
    remoteSearchLine(query){
      this.lineLoading = true;
      this.queryAllCline(query).then(res=>{
        this.airlines = [{id:null,name:'无'},...res]
      })
    },
    remoteSearchEndPoint(query){
      this.startLoading = true;
      this.queryAllCPoint(query).then(res=>{
        this.endLandPoints = res
      })
    },
    //获取起降点信息
    queryAllCPoint(name) {
      return  this.getRequest(
        `/uav-task-server/cpoint/queryAllCPoint?pagesize=20&currentpage=1&keyword=${name}&type=1&type=2`
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            this.startLoading = false;
            this.endLoading = false;
            let pointData = oData.data;
            let pointDataList = pointData.list;

            let pointDataItemList = [];
            for (let i = 0, len = pointDataList.length; i < len; i++) {
              if (2 === pointDataList[i].type || 1 === pointDataList[i].type) {
                pointDataItemList.push(pointDataList[i]);
              }
            }
            return pointDataItemList
          } else if (oData.code != 401) {
          }
        })
        .catch((error) => {
        });
    },
    //获取航线信息
    queryAllCline(name) {
      let vue = this;
      return this.getRequest(
        `/uav-task-server/cairline/queryAllCAirline?pagesize=10&currentpage=1&keyword=${name}`
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            this.lineLoading = false;
            let lineData = oData.data;
            let lineDataList = lineData.list;
            //console.log(lineDataList);
            // if (lineDataList) {
            //   this.airlines = lineDataList;
            //   this.airlines.unshift({id: null, name: '无'})
            // } else {
            //   this.airlines = [];
            // }
            return lineDataList
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {
        });
    },
    //获取飞手信息
    queryFlyer() {
      this.getRequest(
        `/uav-task-server/plan/getFlyerSelectList?operId=${this.operatorId}`
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let flyerDataList = oData.data;

            if (flyerDataList) {
              this.flyers = flyerDataList;
              console.log('飞手--', this.flyers);
            } else {
              this.flyers = [];
            }
          } else if (oData.code != 401) {
          }
        })
        .catch((error) => {
        });
    },
    //获取飞机信息
    queryAircraft() {
      this.getRequest(
        `/user-server/Aircraft/queryAllAircraft?current=1&size=10&keyword=&operatorId=${this.operatorId}`
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let aircraftDataList = oData.data.records;
            if (aircraftDataList) {
              this.aircrafts = aircraftDataList;
              console.log(aircrafts, 4)
            } else {
              this.aircrafts = [];
            }
          } else if (oData.code != 401) {
          }
        })
        .catch((error) => {
        });
    },
    //获取飞手信息
    queryOper() {
      let vue = this;
      this.getRequest(
        "/uav-task-server/plan/getOperSelectList"
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let operDataList = oData.data;

            if (operDataList) {
              this.opers = operDataList;
            } else {
              this.opers = [];
            }
          } else if (oData.code != 401) {
          }
        })
        .catch((error) => {
        });
    },
    //获取空域信息
    querySpace(name) {
      let vue = this;
      return this.getRequest(
        `/uav-task-server/plan/getSpaceSelectList?keyword=${name}`
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let spaceDataList = oData.data;

            if (spaceDataList) {
              this.spaces = spaceDataList;
            } else {
              this.spaces = [];
            }
          } else if (oData.code != 401) {
          }
        })
        .catch((error) => {
        });
    },
    // 处理航线选择改变事件
    handleAirlineChange() {
      const selectedAirline = this.airlines.find(airline => airline.id === this.taskForm.routeId);
      if (selectedAirline) {
        // 更新任务类型输入框的值为所选航线的airLineType
        this.taskForm.type = selectedAirline.airLineType;
        // console.log('更新任务类型--》', selectedAirline.airLineType)
        if (selectedAirline.id === null) {
          this.showSpace = true;
          this.spaceRules();
        } else {
          this.resetSpace();
        }
      }
    },
    filterAircraft() {
    },
    // 处理飞手改变事件
    handleFlyerChange() {
      const selectedFlyer = this.flyers.find(flyer => flyer.pilotId === this.taskForm.pilotId);
      if (selectedFlyer) {
        this.taskForm.pilotId = selectedFlyer.pilotId;
        this.taskForm.pilot = selectedFlyer.pilot;
        this.taskForm.pilotLicense = selectedFlyer.license;
      }
    },
    // 处理飞机改变事件
    handleAircraftChange() {
      const selectedAircraft = this.aircrafts.find(v => v.productId === this.taskForm.uavSerial);
      if (selectedAircraft) {
        this.taskForm.uavModel = selectedAircraft.productModel;
      }
    },
    // 处理运营人改变事件
    handleOperChange() {
      const selectedOper = this.opers.find(oper => oper.operatorNum === this.taskForm.operatorNum);
      if (selectedOper) {
        this.taskForm.operatorName = selectedOper.operatorName;
        this.taskForm.operatorLicense = selectedOper.license;
        this.taskForm.pilotId = ''
        this.taskForm.pilotLicense = ''
        this.operatorId = selectedOper.operId
      }
    },
    // 根据id获取活动信息
    queryFlight(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id).then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              if (data.flight) {
                // 获取当前id活动的 活动流转信息
                this.planCirculationInfos = data.flight.plan_transfer_note
                  ? JSON.parse(data.flight.plan_transfer_note)
                  : [];

                this.flight = data.flight;
                if (!this.isEmptyStr(this.flight.task_coordinate_waypoints)) {
                  const points =
                    this.flight.task_coordinate_waypoints.split(";");
                  this.flight.point_count = points.length;
                } else {
                  this.flight.point_count = 0;
                }
              } else {
                this.flight = {};
              }
              let note = this.flight.note;
              if (note) {
                let notes = note.split(this.replaceStr);
                if (notes && notes.length > 0) {
                  let notee = [];
                  notes.forEach((item) => {
                    if (item) {
                      notee.push(item);
                    }
                  });
                  this.note = notee;
                } else {
                  this.note = "";
                }
              } else {
                this.note = "";
              }
              this.flight.note = "";
              if (data.applyer) {
                this.applyer = data.applyer;
              } else {
                this.applyer = {};
              }
              if (data.auditor) {
                this.auditor = data.auditor;
              } else {
                this.auditor = {};
              }
              if (data.customer_groundstaf) {
                this.customer_groundstaf = data.customer_groundstaf;
              } else {
                this.customer_groundstaf = {};
              }
              if (data.destination_groundstaf) {
                this.destination_groundstaf = data.destination_groundstaf;
              } else {
                this.destination_groundstaf = {};
              }
              if (data.flyer) {
                this.flyer = data.flyer;
              } else {
                this.flyer = {};
              }
              if (data.lsgoods) {
                this.goodsList = data.lsgoods;
              } else {
                this.goodsList = [];
              }
              if (data.security) {
                this.security = data.security;
              } else {
                this.security = {};
              }
              if (data.task_controller) {
                this.task_controller = data.task_controller;
              } else {
                this.task_controller = {};
              }
              if (data.airlink) {
                this.airlink = data.airlink;
              } else {
                this.airlink = {};
              }
              if (data.starstaypoint) {
                this.starstaypoint = data.starstaypoint;
              } else {
                this.starstaypoint = {};
              }
              if (data.endstaypoint) {
                this.endstaypoint = data.endstaypoint;
              } else {
                this.endstaypoint = {};
              }
              if (data.uav) {
                this.uav = data.uav;
              } else {
                this.uav = {uavmodel: {}};
              }
              this.choosePriority();
              this.dealDataAfterGetDetail();
            }
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>活动信息获取失败";
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              confirmButtonClass: "confirm-style",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }
        }
      );
    },
    choosePriority() {
      let priority = this.flight.priority;
      if (1 === priority) {
        this.priority = minimumer;
        this.priorityClass = "minimumer";
      } else if (2 === priority) {
        this.priority = secondaryer;
        this.priorityClass = "secondaryer";
      } else if (3 === priority) {
        this.priority = highester;
        this.priorityClass = "highester";
      }
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      // 设置货物列表信息 start
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        this.goodsName = goodsList[0].goods_name;
        goodsList.forEach(function (goods, index) {
          let attributes = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attributes.push("易碎性");
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attributes.push("易爆性");
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attributes.push("易燃性");
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attributes.push("腐蚀性");
          }
          let attributesStr = "";
          for (let i = 0, len = attributes.length; i < len; i++) {
            if (i === len - 1) {
              attributesStr += attributes[i];
            } else {
              attributesStr += attributes[i] + ",";
            }
          }
          _this.$set(goods, "attributes", attributesStr); //触发更新视图
        });
        _this.goodsList = goodsList;
      } else {
        this.goodsList = [];
      }
    },
    submit(type) {
      if ("pass" === type) {
        this.flight.flight_status = 40;
        this.updateConfirmRelationByFlightApproved();
      } else {
        let note = this.flight.note;
        if (note) {
          this.flight.flight_status = 31;
          this.updateConfirmRelationByFlightApproved();
        } else {
          let tips = "<i class='el-icon-warn-tip'></i>驳回时,需要填写备注哦~";
          this.$confirm(tips, "", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            confirmButtonClass: "confirm-style",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      }
    },
    // 按活动审批的驳回和确认操作
    updateConfirmRelationByFlightApproved() {
      let tips = "<i class='el-icon-warn-tip'></i>确定提交该活动?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        confirmButtonClass: "confirm-style",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.flight.id = this.openedId;
          this.postJsonRequest(
            "/uav-task-server/confirmrelation/updateConfirmRelationByFlightApproved.do",
            this.flight
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.isDetail = false;
              this.getConfirmRelationStaticByFlightApproved();
              this.getConfirmRelationListByFlightApproved();
              this.$message({
                message: oData.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {
                },
              });
            } else if (oData.code != 401) {
              this.$message.error({
                message: oData.msg,
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () {
                }
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeBackground(taskPlanList) {
      if (taskPlanList.status == 0) {
        return "taskTableRedBackground";
      } else if (taskPlanList.status == 1) {
        return "taskTableBlueBackground";
      } else {
        return "taskTable";
      }
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    tableRowClassName({row, rowIndex}) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    goodsListRowClassName({row, rowIndex}) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    searchItem1(val) {
      //模糊搜索 未执行飞行活动
      // console.log('未执行',val);
      this.searchKey1 = val;
      this.unExecutedPlan();
    },
    searchItem2(val) {
      //模糊搜索 已执行飞行活动
      // console.log('已执行',val);
      this.searchKey2 = val;
      this.executedPlan();
    },
  },
  mounted() {
    //this.getConfirmRelationStaticByFlightApproved();
    this.$nextTick(function () {
      // 未执行数据
      this.unExecutedPlan();
      // 已执行和执行中数据
      this.executedPlan();
      //this.getConfirmRelationListByFlightApproved();
      //this.getConfirmRelationListByFlightApprovedCompleted();
    });
    // window.statisicsTimer = setInterval(
    //   this.getConfirmRelationStaticByFlightApproved,
    //   28000
    // ); //28秒轮询一次
    // window.queryTimer = setInterval(
    //   this.getConfirmRelationListByFlightApproved,
    //   100
    // ); //查询待执行数据，4秒轮询一次
    //     window.queryTimer = setInterval(
    //   this.getConfirmRelationListByFlightApprovedCompleted,
    //   100
    // ); //查询已执行数据，4秒轮询一次
    window.queryTimer = setInterval(this.unExecutedPlan, 20000); //查询待执行数据，20秒轮询一次
    window.executedTimer = setInterval(this.executedPlan, 20000); //查询已执行数据，20秒轮询一次
    //   window.queryTimer = setInterval(
    //   this.queryAllCPoint,
    //   80
    // ); //查询起飞点，8秒轮询一次
    // window.queryTimer = setInterval(
    //   this.queryAllCline,
    //   80
    // ); //查询降落点，8秒轮询一次
  },
  beforeDestroy() {
    if (window.executedTimer) {
      clearInterval(window.executedTimer);
      window.executedTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  },
};
</script>
<style scoped>
>>> .category .el-radio__input.is-checked .el-radio__inner {
  background: #00AEFF;
  border-color: #00AEFF;
}

>>> .category .el-radio__label {
  color: #FFFFFF;
}
>>> .el-form-item__label{
  width: 140px !important;
}
>>>.el-dialog__header {
  /* background-image: url(../../img/common/tableHead.png); */
  /* background-position: 15px 13px;
  background-repeat: no-repeat;
  background-size: 300px 35px; */
  padding: 20px 20px 0px 40px ;
  background: url(../../assets/img/2dmap/pop_bg.png)  no-repeat;
  background-position: 18px 25px;
}
</style>




// WEBPACK FOOTER //
// src/components/home/PreacticalPlan.vue